// Firebase SDK importieren
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// DEINE Firebase Konfiguration
const firebaseConfig = {
  apiKey: "AIzaSyCaP1KPmmlgb7ABcQ6BdkjI_GxuTl2hpGg",
  authDomain: "restroom-advisor.firebaseapp.com",
  projectId: "restroom-advisor",
  storageBucket: "restroom-advisor.firebasestorage.app",
  messagingSenderId: "418295324821",
  appId: "1:418295324821:web:08e43a2d298d2ca7bbfb9c"
};


// Firebase initialisieren (startet die Verbindung)
const app = initializeApp(firebaseConfig);

// Services erstellen und exportieren
export const db = getFirestore(app);      // Datenbank
export const storage = getStorage(app);   // Foto-Speicher
export const auth = getAuth(app);         // Authentication